/* eslint-disable react/prop-types */
import classes from "./navbar.module.scss";
import { Link } from "react-router-dom";

import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import SubMenu from "./sub-menu";
import { LINKS } from "@/static-texts/links";
import { SUB_MENUS } from "@/static-texts/sub-menus";
import MobileNav from "./mobile-nav";

function Navbar({
  onClick,
  onClickLogo,
  onCloseSubMenu,
  subMenu,
  onMouseLeave,
  onMouseEnter,
}) {
  return (
    <header className={classes.header}>
      <Flex
        justify="space-between"
        align="center"
        className={classes.header__content}
      >
        <img
          src={"/images/header/PROSSIMITI-logo.svg"}
          alt="Logo"
          onClick={onClickLogo({})}
          className={classes.logo}
        />
        <nav className={classes.header__content__nav}>
          <ul>
            <li>
              <Label
                align="start"
                size="md"
                color="navbar"
                onClick={onClick({})}
                className={classes.link_parent}
              >
                <Link to={LINKS.HOME} className={classes.link_nowrap}>
                  Home
                </Link>
              </Label>
            </li>
            <li>
              <Label
                align="start"
                size="md"
                color="navbar"
                onClick={onClick({})}
              >
                <Link
                  to={LINKS.BUILD_YOUR_SOLUTION}
                  className={classes.link_nowrap}
                >
                  Bandi e Cumulabilitá
                </Link>
              </Label>
            </li>
            <li>
              <div
                onMouseEnter={() => onMouseEnter("finance")}
                onMouseLeave={onMouseLeave}
              >
                <Flex
                  justify="center"
                  align="flex-start"
                  direction="column"
                  className={classes.link_container}
                >
                  <Label
                    size="md"
                    color="navbar"
                    align="start"
                    className={classes.link_parent}
                  >
                    <Link to={LINKS.FINANCE} className={classes.link_nowrap}>
                      Finanza Agevolata
                    </Link>
                  </Label>
                  {subMenu === "finance" && (
                    <SubMenu
                      subMenu={SUB_MENUS.finance}
                      onCloseSubMenu={onCloseSubMenu}
                    />
                  )}
                </Flex>
              </div>
            </li>
            <li>
              <div
                onMouseEnter={() => onMouseEnter("facilitations")}
                onMouseLeave={onMouseLeave}
              >
                <Flex
                  justify="center"
                  align="flex-start"
                  direction="column"
                  className={classes.link_container}
                >
                  <Label
                    size="md"
                    color="navbar"
                    align="start"
                    className={classes.link_parent}
                  >
                    <Link className={classes.link_nowrap}>
                      Agevolazioni in evidenza
                    </Link>
                  </Label>
                  {subMenu === "facilitations" && (
                    <SubMenu
                      subMenu={SUB_MENUS.facilitations}
                      onCloseSubMenu={onCloseSubMenu}
                    />
                  )}
                </Flex>
              </div>
            </li>
            <li>
              <div
                onMouseEnter={() => onMouseEnter("services")}
                onMouseLeave={onMouseLeave}
              >
                <Flex
                  justify="center"
                  align="flex-start"
                  direction="column"
                  className={classes.link_container}
                >
                  <Label
                    size="md"
                    color="navbar"
                    align="start"
                    className={classes.link_parent}
                  >
                    <Link className={classes.link_nowrap}>Servizi</Link>
                  </Label>
                  {subMenu === "services" && (
                    <SubMenu
                      subMenu={SUB_MENUS.services}
                      onCloseSubMenu={onCloseSubMenu}
                    />
                  )}
                </Flex>
              </div>
            </li>
            <li>
              <Label
                align="start"
                size="md"
                color="navbar"
                onClick={onClick({})}
              >
                <Link to={LINKS.ABOUT} className={classes.link_nowrap}>
                  Chi siamo
                </Link>
              </Label>
            </li>
            <li>
              <Label
                align="start"
                size="md"
                color="navbar"
                onClick={onClick({})}
                className={classes.link_parent}
              >
                <Link to={LINKS.PARTNERS} className={classes.link_nowrap}>
                  Partners
                </Link>
              </Label>
            </li>
            <li>
              <Label
                align="start"
                size="md"
                color="navbar"
                onClick={onClick({})}
              >
                <Link to={LINKS.CONTACTS} className={classes.link_nowrap}>
                  Contatti
                </Link>
              </Label>
            </li>
          </ul>
        </nav>
      </Flex>
    </header>
  );
}

function NavbarWrapper(props) {
  const { onClick, onClickLogo, onClickMobile, clickMobile } = props;
  // Use window.matchMedia for mobile detection
  const isMobile =
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 768px)").matches;
  if (isMobile) {
    // return <MobileNavbar {...props} />;
    return (
      <Flex
        justify="space-between"
        align="center"
        direction="column"
        className={classes.content}
      >
        <MobileNav
          clickMobile={clickMobile}
          onClickMobile={onClickMobile}
          onClick={onClick}
          onClickLogo={onClickLogo}
        />
      </Flex>
    );
  }
  return <Navbar {...props} />;
}

export default NavbarWrapper;
